import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    notification: {},
    notificationList: [],
    loading: {},
    error: null
};

export const notificationSlice = createSlice({
    name: "notificationSlice",
    initialState: init,
    reducers: {
        setNotification: (state, action) => {
            state.notification = action.payload;
        },

        setNotifications: (state, action) => {
            state.notificationList = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch data list
        .addCase(fetchNotificationList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchNotificationList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.notificationList = action.payload;
        })
        .addCase(fetchNotificationList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add notification
        .addCase(addNotification.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addNotification.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.notification = action.payload;
        })
        .addCase(addNotification.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update notification
        .addCase(updateNotification.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateNotification.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.notification = action.payload;
        })
        .addCase(updateNotification.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });;
    }
});

export const fetchNotificationList = createAsyncThunk(
    "productSlice/fetchNotificationList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/notifications`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
        }
    }
);

export const updateNotification = createAsyncThunk(
    "notificationSlice/updateNotification",
    async ({ notificationId, notificationData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/notifications/${notificationId}`, notificationData);
            dispatch(fetchNotificationList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update notification");
        }
    }
);

export const addNotification = createAsyncThunk(
    "notificationSlice/addNotification",
    async ({ notificationData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/notifications`, notificationData);
            dispatch(fetchNotificationList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add notification");
        }
    }
);

export const { clearData, setNotification, setNotifications } = notificationSlice.actions;

export default notificationSlice.reducer;
